// @flow

import { useContext } from 'react';

import { SubmittingContext } from './context';

export function useSubmitting(): boolean {
  const context = useContext(SubmittingContext);
  if (typeof context !== 'boolean') {
    throw new Error('Submitting context was not provided');
  }
  return context;
}
